export class FdAnalyticsService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static submitAnalytics(measurementData) {
        if (!measurementData || typeof measurementData !== 'object') {
            console.log('Are you sure you\'ve added data?');
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.Bootstrapper !== 'object' || typeof window.Bootstrapper._trackAnalytics !== 'function') {
            console.log('Bootstraper dependencies not met');
            return;
        }
        // we still don't want to crash app if analytics fails
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.Bootstrapper._trackAnalytics(measurementData);
        }
        catch (err) {
            console.log(err);
        }
    }
}
//# sourceMappingURL=fd-analytics.service.js.map